module.exports = __webpack_public_path__ + "7faeef8ee7ca3cf161134f5bcf2d93e9.svg";